import { render } from "./Fight.vue?vue&type=template&id=2877954a"
import script from "./Fight.vue?vue&type=script&lang=js"
export * from "./Fight.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__